// ============= Imports =============

import { useEffect, useRef } from 'react';

// ============= Hook =============

export const usePrevious = <T>(value: T): T | undefined => {
  const ref = useRef<T | undefined>(undefined);

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
};
